import { Component, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Component({
    standalone: false,
    selector: 'form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.css'],
})
export class FormInputComponent {
    @Input() control!: NgModel;
    @Input() name!: string;
    @Input() help: boolean = false;

    constructor() { }

}
